import _styled from "@emotion/styled/base";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { IconContentCopy, IconFileCopy } from '@travel-frontend/icons';
import { useTranslation } from 'next-i18next';
import { forwardRef, useState, useEffect, useRef } from 'react';
import { Slide } from 'react-toastify';
import { Container } from '../../../../components/Voucher/components/Copy/components/Container.js';
import { ActionLink, Toast } from '../../../../primitives/index.js';
import { useToast } from '../../../../primitives/Toast/hooks/useToast.js';
const CopyComponent = forwardRef(({
  code,
  hidden,
  onCopy,
  ...props
}, ref) => {
  const {
    t
  } = useTranslation('voucher');
  const toast = useToast();
  const [isCopyClicked, setIsCopyClicked] = useState(false);
  const timeoutRef = useRef();
  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);
  return _jsxs(Container, {
    isHidden: hidden,
    ref: ref,
    ...props,
    children: [_jsx(ActionLink, {
      "aria-label": t('buttonAriaLabel'),
      onClick: () => {
        navigator.clipboard.writeText(code);
        setIsCopyClicked(true);
        toast({
          caption: t('toastCaption'),
          variant: 'success',
          containerId: code
        });
        timeoutRef.current = setTimeout(() => setIsCopyClicked(false), 4500);
        onCopy?.();
      },
      disabled: isCopyClicked,
      children: isCopyClicked ? _jsx(IconFileCopy, {}) : _jsx(IconContentCopy, {})
    }), _jsx(Toast, {
      containerId: code,
      autoClose: 4000,
      position: "bottom-center",
      transition: Slide
    })]
  });
});
CopyComponent.displayName = 'Copy';
export const Copy = /*#__PURE__*/_styled(CopyComponent, process.env.NODE_ENV === "production" ? {
  target: "e14c4bpn0"
} : {
  target: "e14c4bpn0",
  label: "Copy"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");